// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:940px){.card[data-v-07f42534]:not(.is-small-screen){border:1px solid var(--c-light-gray);bottom:86px;color:var(--c-black);height:auto;padding:20px 20px 25px;right:24px;width:340px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
